import { IStudentWebinar } from 'models/student-webinar';
import { useEffect, useMemo, useState } from 'react';
import redirectToAuth from 'utilities/redirectToAuth';
import useApi from './useApi';
import useAuthToken from './useAuthToken';
import { AxiosError } from 'axios';
import { BackendError } from 'models/backend-error';

const useStudentWebinar = (
  webinarId: string,
): IStudentWebinar | null => {
  const [ webinar, setWebinar ] = useState<IStudentWebinar | null>(null);

  const { getAuthToken, removeAuthToken } = useAuthToken();
  const authToken = useMemo<string | null>(() => getAuthToken() ?? null, [ getAuthToken ]);

  const api = useApi();

  useEffect(() => {
    if (authToken) {
      api.request<IStudentWebinar>({
        method: 'GET',
        url: `student/webinars/${webinarId}`,
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      }).then(({ data }) => {
        setWebinar(data);
      }).catch((error: AxiosError<BackendError>) => {
        setWebinar(null);

        if (error.response?.status === 401) {
          removeAuthToken();
          redirectToAuth();
        }
      });
    } else {
      redirectToAuth();
    }
  }, [ webinarId, authToken ]);

  return webinar;
};

export default useStudentWebinar;
